import { PoweredBy, PoweredByRuckus } from "./icons";
import { Content, Footer } from "antd/lib/layout/layout";
import { Layout } from "antd";
import { ErrorResponse, useRouteError } from "react-router-dom";
import './error.css';
import { FeatureFlags } from "./types";
import { useSelector } from "react-redux";
import { selectFeatures } from "./store/featuresSlice";
import { ErrorContent } from "./components/error";

interface ErrorPageProps {
  message?: string;
}

const ErrorPage = ({ message = '' }: ErrorPageProps) => {
  useRouteError() as ErrorResponse;
  const features = useSelector(selectFeatures);
  const featureFlags = new FeatureFlags(features);
  const PoweredByLogo = featureFlags.isNuvo2026R1LogoEnabled() ? PoweredByRuckus : PoweredBy;
  
  return (
    <Layout className="error-page-layout">
      <Content>
        <ErrorContent message={message} />
      </Content>
      <Footer className="error-page-footer">
        <PoweredByLogo />
      </Footer>
    </Layout>
  );
};

export default ErrorPage;
